import { Box, Paper, Typography } from "@mui/material";
import { CustomContentProps, SnackbarContent, SnackbarKey, useSnackbar } from "notistack";
import React, { forwardRef } from "react";
import { AvatarImage } from "ui/Scripts/source/components/framework/Avatar/AvatarImage";
import { Base } from "ui/Scripts/source/framework/base";
import { ISignalrNotification } from "ui/Scripts/source/models/common/signalrNotification";
import { EnumHelper, SignalRModuleType } from "ui/Scripts/source/models/enums";
import { customHistory } from "../../../../framework/customHistory";

interface InstantMessageNotificationProps extends CustomContentProps {
    id: SnackbarKey;
  instantMessage: ISignalrNotification;
  onCloseClick?: () => void;
}

const InstantMessageNotification = forwardRef<
  HTMLDivElement,
  InstantMessageNotificationProps
>(({ id, instantMessage, onCloseClick, ...props }, ref) => {
    const { closeSnackbar } = useSnackbar();

    const handleClick = () => {
        if (EnumHelper.isEqual(instantMessage.module, SignalRModuleType.InstantMessage)) {
            customHistory.push(
                "/new/instantmessage" + (instantMessage.recordId ? "/" + instantMessage.recordId : "")
            );
            if (onCloseClick) {
                closeSnackbar(id);
            }
        }
    };

    return (
        <SnackbarContent ref={ref}>
            <Paper
                sx={{
                    bgcolor: "background.default",
                    padding: ".25rem",
                    maxWidth: "400px",
                    border: "1px solid",
                    borderColor: "divider",
                    width: "100%",
                    cursor: "pointer",
                }}
                elevation={6}
                onClick={handleClick}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        bgcolor: "background.paper",
                        padding: "1rem",
                        flexGrow: 1,
                    }}
                >
                    <AvatarImage
                        id={instantMessage.modifyUser.code}
                        name={instantMessage.modifyUser.name}
                        image={instantMessage.modifyUser.picture}
                        tooltip={instantMessage.modifyUser.name}
                        marginRight=".5rem"
                        size={40}
                    />
                    <Box sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
                        <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }} >{instantMessage.body}</Typography>
                        <Typography
                            variant="caption"
                            sx={{
                                textAlign: "right",
                                color: "text.secondary",
                                marginTop: ".5rem",
                            }}
                        >
                            {instantMessage.modifyUser.name + " " + Base.timeToTimeStr(instantMessage.modifyUser.date)}
                        </Typography>
                    </Box>
                </Box>
            </Paper>
        </SnackbarContent>
    );
});

InstantMessageNotification.displayName = "InstantMessageNotification";

export default InstantMessageNotification;
